import './gallery.less'

import {Background, MediaQuery} from '@codeurs/front'
import placeholder from 'assets/images/placeholder.jpg'
import React from 'react'
import {ImageType, WysiwygType} from 'types'
import {t} from 'util/i18n'
import {style} from 'util/style'
import {Trusted} from 'util/trusted'
import {useCookiehub} from 'util/useCookiehub'
import {Theme} from 'views/theme'
import {GalleryDesktop} from './gallerydesktop'
import {GalleryMobile} from './gallerymobile'

const styles = style('gallery', ['iframe', 'cookieplaceholder', 'quote'])

export type GalleryType = {
	images?: Array<ImageType>
	iframe?: string
	quote1?: WysiwygType
	quote2?: WysiwygType
}

export const Gallery: React.FC<GalleryType> = ({
	images,
	iframe,
	quote1,
	quote2
}) => {
	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<MediaQuery
					maxWidth={1023}
					view={() => (
						<GalleryMobile
							images={images}
							iframe={iframe}
							quote1={quote1}
							quote2={quote2}
						/>
					)}
				/>
				<MediaQuery
					minWidth={1024}
					view={() => (
						<GalleryDesktop
							images={images}
							iframe={iframe}
							quote1={quote1}
							quote2={quote2}
						/>
					)}
				/>
			</Theme.OuterContainer>
		</div>
	)
}

export const GalleryBackground: React.FC<{image?: ImageType}> = ({image}) => {
	return <Background img={image && !image.empty ? image : placeholder} />
}

export const GalleryIframe: React.FC<{iframe?: string}> = ({iframe}) => {
	const cookiehub = useCookiehub()
	const allowedCookies =
		cookiehub?.hasAnswered() && cookiehub?.hasConsented('marketing')

	if (!iframe) return null

	return (
		<div className={styles.iframe()}>
			{!allowedCookies && (
				<div className={styles.iframe('cookieplaceholder')}>
					<p className={styles.iframe('cookieplaceholder-text')}>
						{t('cookies.placeholder.text')}
					</p>
					<Theme.Button onClick={() => cookiehub?.openSettings()}>
						{t('cookies.placeholder.button')}
					</Theme.Button>
				</div>
			)}
			{allowedCookies && <Trusted>{iframe}</Trusted>}
		</div>
	)
}

export const GalleryQuote: React.FC<{quote?: WysiwygType}> = ({quote}) => {
	if (!quote) return null

	return (
		<div className={styles.quote()}>
			<Theme.Wysiwyg>{quote}</Theme.Wysiwyg>
		</div>
	)
}
